//@flow
import * as React from 'react';
import {connect} from "react-redux";
import type {
  onDeleteMyOrganizationsSearchProp,
  onUpdateMyOrganizationsSearchProp
} from "../../../../services/flowTypes/propFnFlowTypes";
import type {
  organizationsSearch,
  organizationStatusList
} from "../../../../services/flowTypes/dataFlowTypes";
import text from "../../../../services/localization/text";
import type {selectOptions} from "../../../../services/flowTypes/componentFlowTypes";
import Filters from "../../../../components/composed/Filters/Filters";
import myOrganizationsSearchActions
  from "../../../../store/myOrganizations/myOrganizationsSearch/myOrganizationsSearchActions";

type Props = {
  onUpdateMyOrganizationsSearchProp: onUpdateMyOrganizationsSearchProp,
  organizationStatusList: organizationStatusList,
  onDeleteMyOrganizationsSearchProp: onDeleteMyOrganizationsSearchProp,
  search: organizationsSearch
};
type State = {
  statusOptions: selectOptions
};

class MyOrganizationsFilters extends React.Component <Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      statusOptions: []
    };
  }
  handleOnGetMyOrganizationsFiltersPropCall = (filtersProps) => {
    const myOrganizationsFiltersProps = {...filtersProps};
    if (!myOrganizationsFiltersProps.hasOwnProperty('offset')) {
      myOrganizationsFiltersProps.offset = 0;
    }
    this.props.onUpdateMyOrganizationsSearchProp(myOrganizationsFiltersProps);
  };
  getFiltersList = (allFiltersList) => {
    const filtersList = [];
    const filtersForOptions = [];
    for (let i=0; i < allFiltersList.length; i++) {
      const condition = this.props.search.hasOwnProperty(allFiltersList[i].propName);
      if (condition) {
        filtersList.push(allFiltersList[i]);
      } else {
        filtersForOptions.push(allFiltersList[i]);
      }
    }
    return {filtersList, filtersForOptions};
  };
  componentDidMount() {
    const defaultOption =  {
      value: 'ALL',
      label: text.organizationStatus['ALL'],
      statusClassName: `StatusLabel StatusLabel_ALL`
    };
    const statusOptions = this.props.organizationStatusList.map(item => {
      return {
        value: item,
        label: text.organizationStatus[item],
        statusClassName: `StatusLabel StatusLabel_${item}`
      };
    });
    statusOptions.unshift(defaultOption);
    this.setState({statusOptions})
  }
  render() {
    const allFiltersList = [
      {propName: 'status', formFieldType: 'filter-select', options: this.state.statusOptions, initValue: 'ACTIVE'}
    ];
    const {filtersList, filtersForOptions} = this.getFiltersList(allFiltersList);
    const resetFilters = () => this.props.onDeleteMyOrganizationsSearchProp(['status']);
    return (
      <Filters onGetFiltersProp={this.handleOnGetMyOrganizationsFiltersPropCall}
               onDeleteFiltersProp={this.props.onDeleteMyOrganizationsSearchProp}
               filtersState={this.props.search}
               filtersForOptions={filtersForOptions}
               filtersList={filtersList}
               resetFilters={resetFilters}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    organizationStatusList: state.admin.statuses.organizationStatusList,
    search: state.myOrganizations.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdateMyOrganizationsSearchProp: (myOrganizationsSearchObj) => dispatch({
      type: myOrganizationsSearchActions.MY_ORGANIZATIONS_SEARCH_PROP_UPDATE,
      value: myOrganizationsSearchObj}),
    onDeleteMyOrganizationsSearchProp: (myOrganizationsPropNameArr) => dispatch({
      type: myOrganizationsSearchActions.MY_ORGANIZATIONS_SEARCH_PROP_DELETE,
      value: myOrganizationsPropNameArr
    })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyOrganizationsFilters);
